import { HttpParams } from '@angular/common/http';

export function constructHttpParams(params: unknown): HttpParams {
  let httpParams = new HttpParams();

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, value.toString());
      }
    });
  }
  return httpParams;
}
